import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import articlesReducer from "./reducers/articlesReducer";

const rootReducer = combineReducers({
  articlesReducer,
});

const store = configureStore({ reducer: rootReducer });

export default store;